export default __webpack_public_path__ + "static/media/510.883f4c5c.jpg";